import { Component, Output, EventEmitter, OnInit } from '@angular/core';

import { File } from '@core/objects/file';
import { FileUploadQueue } from '@core/components/storage/storage-files-upload/file-upload-queue.class';


@Component({
    selector: 'organization-profile-logo-upload',
    templateUrl: './upload.component.html',
    styleUrls: ['./upload.component.scss']
})
export class OrganizationProfileLogoUploadComponent implements OnInit {
    // Use MIME type constants from FileUploadQueue for image types
    public allowedImageTypes = FileUploadQueue.ALLOWED_IMAGE_TYPES;
    public isRejected: boolean = false;

    @Output() cancel = new EventEmitter<any>();
    @Output() uploaded = new EventEmitter<File>();

    public ready: boolean = false;
	protected files: File[] = null;

	ngOnInit(){
    }

    upload(filesUploaded: Array<File>) {
        if(filesUploaded.length > 0){
            this.files = filesUploaded;
            this.ready = true;
        } else {
            this.ready = false;
        }
    }

    onCancel() {
        this.ready = false;
        this.cancel.emit(true);
    }

    next() {
        if(this.files.length > 0)
            this.uploaded.emit(this.files[0]);
    }
    
    onFileRejected(event: { filename: string; reason: string }) {
        this.isRejected = true;
    }

    dismissRejection() {
        this.isRejected = false;
    }

}
